var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: {
        value: _vm.value,
        title: _setup.isEditing
          ? "Edit your Crossword Style"
          : "Set Up your Custom Crossword Style",
        size: "lg",
        "hide-footer": "",
      },
      on: {
        input: function ($event) {
          return _setup.emit("input", $event)
        },
        closed: function ($event) {
          return _setup.emit("input", false)
        },
      },
    },
    [
      _c(_setup.CInput, {
        attrs: {
          label: "Style Name",
          type: "text",
          debounce: 0,
          placeholder: "Custom Style",
        },
        model: {
          value: _setup.model.name,
          callback: function ($$v) {
            _vm.$set(_setup.model, "name", $$v)
          },
          expression: "model.name",
        },
      }),
      _vm._v(" "),
      _c("section", { staticClass: "section mt-3" }, [
        _c("header", { staticClass: "section-header" }, [_vm._v("Letters")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section-body" },
          [
            _c(_setup.FontSelector, {
              model: {
                value: _setup.model.font,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "font", $$v)
                },
                expression: "model.font",
              },
            }),
            _vm._v(" "),
            _c(_setup.CInput, {
              attrs: {
                type: "decimal",
                step: ".01",
                label: "Font size (px)",
                placeholder: "0.00",
                error: !_setup.fontSizeIsValid,
                "error-msg": `Use a size between ${_setup.MIN_FONT_SIZE} and ${_setup.MAX_FONT_SIZE} px`,
              },
              model: {
                value: _setup.model.fontSize,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "fontSize", $$v)
                },
                expression: "model.fontSize",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "color-field" },
              [
                _c("label", [_vm._v("Color")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "framed-row",
                    on: { click: _setup.toggleColorPicker },
                  },
                  [
                    _c("span", {
                      staticClass: "color-preview",
                      style: { backgroundColor: _setup.model.color.hex },
                    }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_setup.model.color.hex) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(_setup.ColorSelector, {
                  ref: "pickerRef",
                  attrs: {
                    open: _setup.clickOutsideActive,
                    color: _setup.model.color,
                  },
                  on: {
                    cancel: _setup.toggleColorPicker,
                    "color-selected": _setup.onColorSelected,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "section mt-3" }, [
        _c("header", { staticClass: "section-header" }, [_vm._v("Tile Image")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section-body" },
          [
            _c("label", [_vm._v("Tile Image")]),
            _vm._v(" "),
            _c(_setup.CImageUploadRow, {
              attrs: {
                value: _setup.tileFiles,
                "image-url": _setup.tileImageUrl,
                name: _setup.tileImageName,
                accept: _setup.TILE_IMAGE_ACCEPT,
                "max-mb-size": _setup.TILE_IMAGE_MAX_MB,
                disabled: _setup.uploading,
                removable: !!_setup.model.tileImage,
              },
              on: {
                input: _setup.onTileImageUpload,
                remove: _setup.removeTileImage,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-between custom-footer" },
        [
          _c(_setup.CButton, {
            attrs: {
              text: _setup.isEditing ? "Cancel" : "Back",
              variant: "secondary",
            },
            on: { click: _setup.handleBack },
          }),
          _vm._v(" "),
          _c(_setup.CButton, {
            attrs: {
              text: _setup.isEditing ? "Save Style" : "Create Style",
              variant: "primary",
              disabled: !_setup.canCreate,
            },
            on: { click: _setup.handleSave },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }